import { PreviewEmailDetails } from "shared";
import { When } from "react-if";

import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";

interface EmailPreviewDetailsProps {
  email?: PreviewEmailDetails;
}

/** The envelope (subject, sender and recipients) shown above an email preview body */
export function EmailPreviewDetails({ email }: EmailPreviewDetailsProps) {
  if (!email) return null;

  const rows = [
    { label: `Subject`, value: email.subject },
    { label: `From`, value: email.from },
    { label: `Reply To`, value: email.replyTo },
    { label: `To`, value: email.to?.join(`, `) },
    { label: `Cc`, value: email.cc?.join(`, `) },
    { label: `Bcc`, value: email.bcc?.join(`, `) },
    { label: `Also sent to`, value: email.alsoSentTo?.join(`, `) },
  ].filter(row => !!row.value);

  if (!rows.length) return null;

  return (
    <div className={ `mb-3 pb-3 space-y-1 border-b border-gray-200` }>
      {
        rows.map(row => (
          <div
            key={ row.label }
            className={ `flex gap-2` }
          >
            <Paragraph
              variant={ `secondary` }
              className={ `w-24 shrink-0` }
            >
              { `${row.label}:` }
            </Paragraph>
            <Paragraph className={ `wrap-break-word` }>
              { row.value }
            </Paragraph>
          </div>
        ))
      }

      <When condition={ !!email.alsoSentTo?.length }>
        <Paragraph variant={ `help` }>
          { `Each of these recipients gets their own copy of this email.` }
        </Paragraph>
      </When>
    </div>
  );
}
